import React, { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import TenantService from "../../services/TenantService";

export default function AcceptTerms() {
    const {register, formState: {errors}} = useFormContext();
    const [termsUrl, setTermsUrl] = useState(null);

    useEffect(() => {
        TenantService.getTenantInfo()
            .then(response => {
                if (response.data?.terms_url) {
                    setTermsUrl(response.data.terms_url);
                }
            })
            .catch(err => {
                console.error('Failed to fetch tenant info:', err);
            });
    }, []);

    return (
        <>
            <div className="flex items-center mb-4">
                <input name="acceptTerms" type="checkbox" {...register('acceptTerms', {required: true})} id="acceptTerms" className={`w-4 h-4 mr-2 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 form-check-input ${errors.acceptTerms ? 'is-invalid' : ''}`} />
                <label htmlFor="acceptTerms" className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                    Jag godkänner {termsUrl ? (
                        <a href={termsUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 dark:text-blue-500 hover:underline">bokningsvillkoren</a>
                    ) : (
                        <span>bokningsvillkoren</span>
                    )}.
                </label>
            </div>
            {errors.acceptTerms && (
                <div className="invalid-feedback text-red-800 text-sm mb-2">
                    Du måste godkänna våra bokningsvillkor för att kunna slutföra bokningen.
                </div>
            )}
        </>
    );
}
